export enum WeightLossMedications {
  SEMAGLUTIDE = "SEMAGLUTIDE",
  TIRZEPATIDE = "TIRZEPATIDE",
  PHENTERMINE = "PHENTERMINE",
  B12 = "B12",
  B12_PLUS = "B12_PLUS",
  LIPO_EXTREME = "LIPO_EXTREME",
  TENUATE = "TENUATE",
  PHENDIMETRAZINE = "PHENDIMETRAZINE",
  ZOFRAN_ODT = "ZOFRAN_ODT",
  NAD_PLUS = "NAD_PLUS",
}

// Oral medications that require frequency tracking
export const ORAL_MEDICATION_NAMES: ReadonlyArray<string> = [
  WeightLossMedications.PHENTERMINE,
  WeightLossMedications.PHENDIMETRAZINE,
  WeightLossMedications.ZOFRAN_ODT,
] as const;
